"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Icon_1 = __importDefault(require("@material-ui/core/Icon"));
var StyledFormControlLabel = styled_components_1["default"](FormControlLabel_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 7px 3px;\n  padding-right: 13px;\n  background-color: ", ";\n  border-radius: 5px;\n  border: 1px solid #eaeaea;\n  margin: 2px;\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  span:first-child {\n    height: auto !important;\n    width: 36px !important;\n  }\n"], ["\n  padding: 7px 3px;\n  padding-right: 13px;\n  background-color: ", ";\n  border-radius: 5px;\n  border: 1px solid #eaeaea;\n  margin: 2px;\n  ",
    "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  span:first-child {\n    height: auto !important;\n    width: 36px !important;\n  }\n"])), function (props) { return props.style.bgColor; }, function (props) {
    return props.style.selectedColor !== 'black' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 2px solid ", ";\n    "], ["\n      border: 2px solid ", ";\n    "])), props.style.selectedColor);
}, function (props) { return props.style.bgHoverColor; });
var StyledRadio = styled_components_1["default"](Radio_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 !important;\n"], ["\n  padding: 0 !important;\n"])));
var MyOption = function (props) {
    var value = props.value, name = props.name, label = props.label, selected = props.selected, checkedIcon = props.checkedIcon, uncheckedIcon = props.uncheckedIcon, _a = props.selectedColor, selectedColor = _a === void 0 ? 'black' : _a, simple = props.simple, onChange = props.onChange, id = props.id;
    var optionStyles = {
        bgColor: '#f8f8f8',
        bgHoverColor: '#efefef',
        selectedColor: selectedColor
    };
    var handleChange = function () {
        onChange({ name: name, value: value });
    };
    var radio = (react_1["default"].createElement(StyledRadio, { name: name, checked: selected, icon: react_1["default"].createElement(Icon_1["default"], { color: "primary" }, uncheckedIcon), checkedIcon: react_1["default"].createElement(Icon_1["default"], { color: "primary" }, checkedIcon), onChange: handleChange }));
    if (simple) {
        radio = (react_1["default"].createElement(StyledRadio, { name: name, checked: selected, onChange: handleChange, color: "primary" }));
    }
    return (react_1["default"].createElement(StyledFormControlLabel, { control: radio, label: label, id: id ? id : name, style: optionStyles, value: value }));
};
exports["default"] = MyOption;
var templateObject_1, templateObject_2, templateObject_3;
